import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";

const poolData = {UserPoolId: "us-east-1_b9P7Rn4ne", ClientId: "7bcp61emm6pa3np7q5no3mbhb2"};
const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

// React
const cognitoUser = userPool.getCurrentUser();
  if (cognitoUser != null) {
    cognitoUser.getSession((err, session) => {
      if (err) {
        // console.log(err);
      } else if (!session.isValid()) {
        // console.log("Invalid session.");
      } else {
      }
    
    });
  } else {
    // console.log("User not found.");
  }

export const tokenn = cognitoUser?.signInUserSession?.idToken.jwtToken;
export const acesstokenn=  cognitoUser?.signInUserSession?.accessToken.jwtToken;